import React from 'react';
import { Waves, Footprints, Sailboat, Bike, Wind, Landmark, BookOpen, ShoppingBag, Fish, Anchor } from 'lucide-react';

const activities = [
  {
    icon: <Waves className="h-6 w-6" />,
    title: "Baignade",
    description: "Plage de la Grève Blanche à 5 min à pied — grande plage de sable blanc, idéale pour les familles",
  },
  {
    icon: <Footprints className="h-6 w-6" />,
    title: "Randonnée côtière",
    description: "Sentier GR34 accessible à pied depuis la maison — panoramas époustouflants sur l'Atlantique",
  },
  {
    icon: <Sailboat className="h-6 w-6" />,
    title: "Kayak & paddle",
    description: "Location à proximité — partez explorer les estuaires, îlots et criques de la côte des Abers",
  },
  {
    icon: <Anchor className="h-6 w-6" />,
    title: "Plongée sous-marine",
    description: "Sites parmi les plus riches du Finistère Nord, avec une faune et flore marines exceptionnelles",
  },
  {
    icon: <Bike className="h-6 w-6" />,
    title: "Vélo & VTT",
    description: "Pistes cyclables et chemins côtiers tout autour de Plouguerneau et de l'aber Wrac'h",
  },
  {
    icon: <Wind className="h-6 w-6" />,
    title: "Surf & body-board",
    description: "Spots de surf à moins de 20 min (Porsall, Lampaul-Plouarzel) pour tous niveaux",
  },
  {
    icon: <Landmark className="h-6 w-6" />,
    title: "Phare de l'Île Vierge",
    description: "Le plus haut phare maçonné d'Europe — excursion en bateau depuis le port de Plouguerneau",
  },
  {
    icon: <Fish className="h-6 w-6" />,
    title: "Pêche & cueillette",
    description: "Pêche à pied aux coquillages et crustacés lors des grandes marées bretonnes",
  },
  {
    icon: <BookOpen className="h-6 w-6" />,
    title: "Culture bretonne",
    description: "Musée des Goémoniers à Plouguerneau, festivals bretons et marchés locaux hebdomadaires",
  },
  {
    icon: <ShoppingBag className="h-6 w-6" />,
    title: "Brest & Landerneau",
    description: "Villes à 35–40 min — restaurants, musées, marché et vie culturelle toute l'année",
  },
];

const ActivitiesSection = () => {
  return (
    <div className="max-w-5xl mx-auto">
      <h2 className="text-3xl font-semibold mb-4 text-center">Activités & environs</h2>
      <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto">
        Plouguerneau et la côte des Abers offrent un terrain de jeu exceptionnel, que vous soyez adeptes de nature, de sport ou de culture bretonne.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {activities.map((activity, index) => (
          <div key={index} className="flex items-start gap-4 bg-white rounded-xl border border-gray-100 shadow-sm p-5 hover:shadow-md transition-shadow">
            <div className="bg-blue-50 p-3 rounded-full shrink-0 text-blue-500">
              {activity.icon}
            </div>
            <div>
              <h3 className="font-semibold text-gray-800 mb-1">{activity.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{activity.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivitiesSection;
